// extracted by mini-css-extract-plugin
export var container = "_7b-0";
export var error = "_7b-9";
export var label = "_7b-5";
export var light = "_7b-6";
export var md = "_7b-3";
export var sm = "_7b-2";
export var thin = "_7b-8";
export var thinBold = "_7b-7";
export var vertical = "_7b-4";
export var xs = "_7b-1";